import React, { useState } from 'react'
import { Button, Box, TextInput, Select as SelectG } from 'grommet'
import { Add } from 'grommet-icons'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { setPeople } from '../../redux/rtg/actions'
import { device } from '../../theme/device'
import Icon from '../ReactRTG/IconInput'
import TipDrop from '../Button/TipDrop'

const MainInputButton = styled(Button)`
  background-color: ${props => props.theme.global.colors.primaryBg};
  border-radius: ${props => props.theme.button.border.radius};
  padding: 0rem 1.3rem;
  /* &:hover {
    box-shadow: 0px 0px 0px 2px ${props => props.theme.global.colors.primaryBg};
  } */
  /* @media ${device.medium} {
    padding: 0rem 1rem;
  } */
`

const MainInputData = styled(TextInput)`
  background-color: ${props => props.theme.global.colors.primaryBg};
  border: none;
  border-radius: 0px;
`

const Select = styled(SelectG)`
  padding: 0.2rem 0;
  max-width: 3rem;
  text-align: center;
`

const SelectBox = styled(Box)`
  & > button {
    border: none;
  }
`

const MainInput = () => {
  const [value, setValue] = useState('')
  const [gender, setGender] = useState('unisex')
  const [label, setLabel] = useState('A')
  const people = useSelector(state => state.rtg.people)
  const evenSplit = useSelector(state => state.rtg.evenSplit)
  const dispatch = useDispatch()

  const clicked = input => {
    if (input === '') return
    let inputs = people.slice(0)
    let inputName = input
    //check duplicate name for max 20
    for (let i = 1; i <= 20; i++) {
      if (inputs.some(person => person.name === inputName)) {
        inputName = `${input} (${i})`
      } else {
        break
      }
    }
    inputs.push({ name: inputName, gender, label, filtered: false })
    dispatch(setPeople(inputs.slice(0)))
    setValue('')
  }

  const handleKeyPress = target => {
    if (target.charCode === 13) {
      clicked(value)
    }
  }

  return (
    <Box
      direction="row"
      gap=".7rem"
      margin={{ top: '1.2rem' }}
      background="primaryBg"
    >
      <Box flex={true}>
        <MainInputData
          type="text"
          enterKeyHint="go"
          placeholder="Input here..."
          value={value}
          onChange={event => setValue(event.target.value)}
          onKeyPress={handleKeyPress}
        />
      </Box>

      {evenSplit === 'Gender' && (
        <Box direction="row" align="center" gap=".5rem">
          <Icon
            size="3rem"
            name="UnisexIcon"
            active={gender === 'unisex' ? true : false}
            clicked={() => setGender('unisex')}
          />
          <Icon
            size="3rem"
            name="MaleIcon"
            active={gender === 'male' ? true : false}
            clicked={() => setGender('male')}
          />
          <Icon
            size="3rem"
            name="FemaleIcon"
            active={gender === 'female' ? true : false}
            clicked={() => setGender('female')}
          />
        </Box>
      )}
      {evenSplit === 'Label' && (
        <SelectBox direction="row">
          <Select
            options={['A', 'B', 'C', 'D', 'E', 'F', 'G']}
            value={label}
            onChange={({ option }) => setLabel(option)}
            tabIndex="-1"
          />
        </SelectBox>
      )}
      <TipDrop content="Add Name / Press Enter" position="bottom">
        <MainInputButton
          tabIndex="-1"
          icon={<Add color="text" />}
          onClick={() => clicked(value)}
        />
      </TipDrop>
    </Box>
  )
}

export default MainInput
